const KEY_MAX_WORDS_AMOUNT = 7;

/**
 * Makes an appropriate object key from the string
 * Example: 'Lorem ipsum dolor sit amet' -> 'lorem_ipsum_dolor_sit_amet'
 * */

export const getStoreKeyFromString = (string: TemplateStringsArray | string) => {
    // empty string
    if (!string) return '';

    // number
    if (typeof string === 'number') return string;

    const stringBuilder = (str: string) => str
        .replace(/[^a-zA-Z0-9\s]/g, '') // replace all symbols
        .split(' ') // make array of words
        .slice(0, KEY_MAX_WORDS_AMOUNT) // define max limit of words
        .map(string => string.trim())
        .filter(item => item)
        .join('_') // concat with _ symbol
        .toLowerCase(); // make lower case

    // not 'template string' but usual string
    if (typeof string === 'string') return stringBuilder(string as string);

    // default
    const concatString = string.join('') // make string from template string

    return stringBuilder(concatString);
};